import GuestLayout from '../../layouts/GuestLayout';
import { Block } from '../Patterns';
import { Link } from 'react-router-dom';
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from 'react';
import 'animate.css';


export default function Overview() {

    useEffect(() => {
        AOS.init();
        AOS.refresh();
    }, [])
    return (
        <GuestLayout>
            {/* header */}
            <section className="realtive">
                <div className=" h-52 md:w-4/12 w-3/4 top-80 absolute opacity-60 -left-3">
                    <Block />
                </div>
                <header className="header py-8 under-1 bg-white  flex items-center md:justify-between justify-center md:flex-row flex-col-reverse w-full xl:px-40 md:px-20 px-6 relative">
                    <div className="lg:w-2/4 md:w-3/5 w-full -mt-8 pb-32 md:pb-0 md:mt-0 animate__animated animate__fadeIn">
                        <h2 className="xl:text-4xl lg:text-3xl font-bold text-2xl mb-4 md:text-start text-center font-fira">Resolve your issue easily <br /> and risk free</h2>
                        <p className="lg:text-lg text-sm md:text-start text-center font-taviraj font-semibold">
                            The first independent online  mediation solution, for civil matters fully digital and assisted by Artificial Intelligence.
                        </p>
                        <div className="flex items-center gap-6 md:justify-start justify-center mt-6">
                            <Link to="/auth/sign-in" className="py-3 px-6 border-2 rounded text-xs cursor-pointer text-white transition delay-200 hover:bg-blue-900 font-semibold bg-blue-800 border-blue-800">
                                GET STARTED
                            </Link>
                            {/* <Link to="/guidelines" className="py-3 px-6 border-2 border-green-800 bg-green-800 rounded text-xs text-white cursor-pointer font-semibold hover:bg-green-900 transition delay-200 ease-in-out ">
                                LEARN HOW
                            </Link> */}
                        </div>
                    </div>
                    <div className="lg:w-2/4 md:w-2/5 w-full pt-6 lg:pt-0 lg:mb-0 mb-8">
                        <img src="/meeting.png" className='w-full h-[340px] object-cover' alt="" />
                    </div>

                </header>
                <Link to="/guidelines" className="text-sm py-4 px-6 blue-bg text-white hover:bg-blue-900 -right-8 rotate-90 font-semibold absolute top-32">
                    Guidelines
                </Link>
            </section>


            {/* Features */}
            <section className="blue-bg md:py-24 py-24 wrapper text-white relative">
                <h4 className="font-bold text-2xl mb-6 font-fira">RESOLVE YOUR DISPUTES IN 7 EASY STEPS</h4>
                <div className="grid lg:grid-cols-4 gap-4 grid-cols-1 mt-12">
                    <div data-aos="fade-up" className="rounded-md py-6 px-4 flex items-center justify-center flex-col border-2 border-gray-100 font-semibold relative">
                        <span className="absolute shadow-md -top-2 -left-2 bg-white py-1 text-xs px-2 rounded-lg text-gray-800">
                            1
                        </span>
                        <p className="text-sm text-center">Register and submit a dispute (whether alone or with others as your co-claimants)</p>
                    </div>
                    <div data-aos="fade-up" className="rounded-md py-6 px-4 flex items-center justify-center flex-col border-2 border-gray-100 font-semibold relative">
                        <span className="absolute shadow-md -top-2 -left-2 bg-white py-1 text-xs px-2 rounded-lg text-gray-800">
                            2
                        </span>
                        <p className="text-sm text-center">Counterparty receives an invitation/notice</p>
                    </div>
                    <div data-aos="fade-up" className="rounded-md py-6 px-4 flex items-center justify-center flex-col border-2 border-gray-100 font-semibold relative">
                        <span className="absolute shadow-md -top-2 -left-2 bg-white py-1 text-xs px-2 rounded-lg text-gray-800">
                            3
                        </span>
                        <p className="text-sm text-center">
                            A system guided negotiation is initiated by our AI (if successfully, a terms of settlement is generated for execution by parties. otherwise, you proceed to step 4)
                        </p>
                    </div>
                    <div data-aos="fade-up" className="rounded-md py-8 px-4 flex items-center justify-center flex-col border-2 border-gray-100 font-semibold relative">
                        <span className="absolute shadow-md -top-2 -left-2 bg-white py-1 text-xs px-2 rounded-lg text-gray-800">
                            4
                        </span>
                        <p className="text-sm text-center">
                            A Neutral is matched to your case and appointed for facilitated settlement
                        </p>
                    </div>
                </div>

                {/* <img src={logo} className=" h-18 w-80 absolute md:top-30 bottom-12 opacity-40 right-4" alt=""  /> */}
                <div className="grid md:grid-cols-3 grid-cols-1 gap-6 mt-8 justify-center align-middle ">
                    <div data-aos="fade-up" className="rounded-md py-8 px-4 flex items-center transition delay-300 ease-in-out hover:shadow-lg justify-center flex-col border-2 border-gray-100 font-semibold relative">
                        <span className="absolute shadow-md -top-2 -left-2 bg-white py-1 text-xs px-2 rounded-lg text-gray-800">
                            5
                        </span>
                        <p className="text-sm text-center">
                            Participate in the virtual/online resolution proceedings
                        </p>
                    </div>
                    <div data-aos="fade-up" className="rounded-md py-8 px-4 flex items-center transition delay-300 ease-in-out hover:shadow-lg justify-center flex-col border-2 border-gray-100 font-semibold relative">
                        <span className="absolute shadow-md -top-2 -left-2 bg-white py-1 text-xs px-2 rounded-lg text-gray-800">
                            6
                        </span>
                        <p className="text-sm text-center">
                            Jointly agree on a binding terms of settlement
                        </p>
                    </div>
                    <div data-aos="fade-up" className="rounded-md py-8 px-4 flex items-center transition delay-300 ease-in-out hover:shadow-lg justify-center flex-col border-2 border-gray-100 font-semibold relative">
                        <span className="absolute shadow-md -top-2 -left-2 bg-white py-1 text-xs px-2 rounded-lg text-gray-800">
                            7
                        </span>
                        <p className="text-sm text-center">
                            Initiate process for enforcement of the terms of settlement
                        </p>
                    </div>
                </div>
            </section>


            {/* CTA */}
            <section className="py-24 wrapper bg-white">
                <h2 className="mb-16 font-fira text-3xl text-center">
                    The U-Resolve® 2-Step Resolution Model
                </h2>
                <div className="grid md:grid-cols-3 grid-cols-1 gap-8">
                    <div data-aos="fade-down-left" className="col-span-1 py-3 blue-bg rounded-xl items-center flex justify-center">
                        <img src="/handshake.svg" className='h-40' alt="" />
                    </div>
                    <div data-aos="fade-down-right" className="md:col-span-2 col-span-1">
                        <h3 className="text-2xl font-semibold font-fira">Negotiation</h3>
                        <p className="text-sm mt-4 text-justify mb-6">
                            Negotiation is an alternative dispute resolution (ADR) process in which parties voluntarily come together either personally or by their representatives, to discuss their differences and attempt to reach a joint decision or a resolution of the conflict, on their own and without the involvement of a 3rd party.
                        </p>
                        <Link to="/auth/sign-up" className="mt-4 py-3 px-6 text-sm rounded-md hover:bg-blue-900 transition delay-150 ease-in-out bg-blue-800 text-white font-semibold">
                            Get Started
                        </Link>
                    </div>

                </div>

                <div className="grid md:grid-cols-3 grid-cols-1 mt-24 gap-8">
                    <div data-aos="fade-up-left" className="md:col-span-2 col-span-1">
                        <h3 className="text-2xl font-semibold font-fira">Facilitated Settlement</h3>
                        <p className="text-sm mt-4 text-justify mb-6">

                            Facilitated settlement is an ADR process in which a neutral and impartial 3rd party called the Neutral is chosen by the disputing parties to facilitate the resolution of their dispute. The Neutral facilitates communication and uses problem-solving techniques to enable parties to reach a settlement/ mutual agreement.
                        </p>
                        <Link to="/auth/sign-up" className="mt-4 py-3 px-6 text-sm rounded-md hover:bg-blue-900 transition delay-150 ease-in-out bg-blue-800 text-white font-semibold">
                            Get Started

                        </Link>
                    </div>

                    <div data-aos="fade-up-right" className="col-span-1 blue-bg py-3 px-4 rounded-xl flex justify-center items-center">
                        <img src="/briefcase.svg" className='h-40' alt="" />
                    </div>

                </div>
            </section>


            <section className="py-24 wrapper blue-bg">
                <h3 className="text-3xl font-fira font-semibold mb-12">Why U-Resolve® ODR?</h3>
                <div className="grid md:grid-cols-2 grid-cols-1 gap-6">
                    <div data-aos="fade-in" className="border-2 border-gray-100 py-3 px-6 rounded-lg font-taviraj">
                        It is cheaper and faster than litigation/going to court, which can be time-consuming.
                    </div>

                    <div data-aos="fade-in" className="border-2 border-gray-100 py-3 px-6 rounded-lg font-taviraj">
                        It is a voluntary, informal, flexible, parties-driven process, and parties can determine times and pace.
                    </div>

                    <div data-aos="fade-in" className="border-2 border-gray-100 py-3 px-6 rounded-lg font-taviraj">
                        The parties to the dispute can determine the Coram, by choosing the neutral who will preside over their case. Where they fail to agree on one, the system, utilising advanced AI, allots an appropriate and suitably qualified Neutral.
                    </div>

                    <div data-aos="fade-in" className="border-2 border-gray-100 py-3 px-6 rounded-lg font-taviraj">
                        It is convenient, as it requires the use of ICT majorly, therefore, parties can participate irrespective of their location.
                    </div>

                    <div data-aos="fade-in" className="border-2 border-gray-100 py-3 px-6 rounded-lg font-taviraj">
                        It is cost effective and usually do not cost as much as litigation. 
                    </div>

                    <div data-aos="fade-in" className="border-2 border-gray-100 py-3 px-6 rounded-lg font-taviraj">
                        Once parties bind themselves to resolutions through a settlement agreement, jurisdictional issues can be avoided altogether.
                    </div>

                    <div data-aos="fade-in" className="border-2 border-gray-100 py-3 px-6 rounded-lg font-taviraj">
                        Preservation of the relationship between the parties, as it is typically a win-win situation on both sides of parties to the dispute.
                    </div>

                    <div data-aos="fade-in" className="border-2 border-gray-100 text-justify py-3 px-6 rounded-lg font-taviraj">
                        Privacy of the parties is preserved, as opposed to in a litigation where the process is generally held in public.
                    </div>
                </div>
            </section>

            <section className="wrapper bg-white py-20">
                <h3 className="text-3xl font-fira font-semibold text-center">What You Should Bear in Mind</h3>
                <p className="text-sm font-semibold text-center mt-4 mb-12">ODR/ADR is not valid and/or appropriate in certain cases, such as:</p>

                <div className="">
                    <div data-aos="fade-in" className="py-4 px-6 mb-3 border-2 border-blue-900 rounded-xl flex justify-center items-center flex-col">
                        <p className="text-justify">
                            Where parties to the dispute have agreed to other ADR method in the underlying Agreement regulating their relationship.
                        </p>
                    </div>

                    <div data-aos="fade-in" className="py-4 px-6 mb-3 border-2 border-blue-900 rounded-xl flex justify-center items-center flex-col">
                        <p className="text-justify">
                            Criminal cases generally
                        </p>
                    </div>

                    <div data-aos="fade-in" className="py-4 px-6 mb-3 border-2 border-blue-900 rounded-xl flex justify-center items-center flex-col">
                        <p className="text-justify">
                            Election petitions
                        </p>
                    </div>


                    <div data-aos="fade-in" className="py-4 px-6 mb-3 border-2 border-blue-900 rounded-xl flex justify-center items-center flex-col">
                        <p className="text-justify">
                            Dissolution of marriage, nullity of a void marriage, and restitution of conjugal rights.
                        </p>
                    </div>

                    <div data-aos="fade-in" className="py-4 px-6 mb-3 border-2 border-blue-900 rounded-xl flex justify-center items-center flex-col">
                        <p className="text-justify">
                            Dispute relating to binding interpretations of the law, statute, or document
                        </p>
                    </div>

                    <div data-aos="fade-in" className="py-4 px-6 mb-3 border-2 border-blue-900 rounded-xl flex justify-center items-center flex-col">
                        <p className="text-justify">
                            Cases of urgency seeking immediate reliefs like an injunction
                        </p>
                    </div>

                    <div className="py-4 px-6 border-2 border-blue-900 rounded-xl flex justify-center items-center flex-col">
                        <p className="text-justify">
                            Matters where the extant laws vest express/sole jurisdiction in the courts
                        </p>
                    </div>

                </div>

            </section>

            <section className="wrapper blue-bg py-24 relative">
                <p className="text-center leading-6 text-white">
                    When you submit a dispute for settlement, our assessment team shall conduct a preliminary audit of your case and documents
                    to determine whether it can be onboarded on the U-Resolve® platform for resolution, before an invitation is sent to the counter-party.
                </p>
                <div className="flex justify-center">
                    <Link to="/auth/sign-up" className="mt-4 py-3 px-6 text-xs rounded-md mx-auto hover:shadow-md transition delay-150 ease-in-out bg-white text-blue-900 font-semibold">
                        Get Started
                    </Link>
                </div>
            </section>

            {/* <section className="wrapper bg-white py-32 flex md:justify-between justify-start md:flex-row flex-col items-start md:items-center">
                <h4 className="text-2xl font-semibold font-fira mb-8 md:mb-0">Coming Soon On</h4>
                <div className="flex justify-end gap-8">
                    <button className="font-semibold text-sm py-3 gap-1 px-6 text-blue-900 hover:bg-blue-200 flex items-center border-blue-900 border-2 rounded-md font-fira">
                        <img src="/google-play-icon.svg" className="h-6 w-6" alt="icon" />
                        <span>Play Store</span>
                    </button>
                    <button className="font-semibold text-sm py-3 gap-1 px-6 text-blue-900 hover:bg-blue-200 flex items-center border-blue-900 border-2 rounded-md font-fira">
                        <img src="/apple-app-store.svg" className="h-6 w-6" alt="icon" />
                        <span>App Store</span>
                    </button>
                </div>
            </section> */}

        </GuestLayout>
    );
}
